export const MESSAGE_TEXT = {
  PASSWORD_CHANGED: 'message.your-password-was-changed',
  FIRST_NAME_CHANGED: 'message.first-name-was-changed',
  LAST_NAME_CHANGED: 'message.last-name-was-changed',
  COUNTRY_CHANGED: 'country-settings.country-was-changed',
  VERIFICATION_EMAIL_SENT: 'message.verification-email-was-sent',
  FORGOT_PASSWORD_SUCCESS: 'message.forgot-password-success',
  SELECT_MILES_PROGRAM_DESCRIPTION: 'exchange.select-ff-program',
  CONNECT_PROGRAM_TO_EXCHANGE: 'exchange.connect-program-to-exchange',
  ENTER_POINTS_TO_EXCHANGE: 'exchange.enter-points-to-exchange',
  RECEIVE_POINTS: 'message.you-will-receive-following-amount-of-points',
  REWARD_CODE_SUCCESS: 'message.reward-code-success',
  NFT_SUCCESS_DESCRIPTION: 'brand:nft.received-nft-success',
  SELECT_PROGRAM_TO_EXCHANGE: 'exchange.select-program-to-exchange'
}

export const ERROR_TEXT = {
  FIELD_REQUIRED: 'error.field-required',
  INVALID_EMAIL_ADDRESS: 'error.invalid-email-address',
  INVALID_PASSWORD: 'error.invalid-password',
  INVALID_NUMBER_FORMAT: 'error.invalid-number-format',
  SOMETHING_WENT_WRONG: 'error.something-went-wrong',
  ATTEMPT_LIMIT_EXCEEDED: 'error.attempt-limit-exceeded',
  ACCESS_DENIED: 'error.access-denied',
  NEED_AT_LEAST_ONE_POINT: 'error.need-at-least-one-point',
  FORGOT_PASSWORD_ERROR: 'error.forgot-password-error',
  EMAIL_ALREADY_EXISTS: 'error.email-already-exists',
  INCORRECT_OLD_PASSWORD: 'error.old-password-incorrect',
  EMAIL_VERIFICATION_FAILED: 'error.email-verification-failed',
  PASSWORD_LINK_EXPIRED: 'error.password-reset-link-expired',
  RECEIVE_REWARD_FAILED: 'error.receive-reward-failed',
  OLD_NEW_PASSWORDS_SAME: 'error.old-new-passwords-are-same',
  EXCEED_MAX_LIMIT: 'error.exceed-max-limit',
  NOT_SUFFICIENT_AMOUNT: 'error.not-sufficient-amount',
  INVALID_ACCOUNT_NUMBER: 'error.invalid-account-number',
  RESEND_EMAIL_VERIFICATION_FAILED: 'error.failed-to-resend-verification-email',
  FAILED_TO_VERIFY_CLAIM_REWARD: 'quest.failed-verify-claim-reward'
}

export const LABEL_TEXT = {
  MAX: 'max',
  MIN: 'min',
  LOGIN: 'Login',
  SIGNUP: 'Signup',
  REDEEM_POINTS: 'redeem.redeem-points',
  GET_DISCOUNTS: 'redeem.get-discounts',
  GET_MILES: 'exchange.get-miles',
  GET_DISCOUNTS_ON_BRAND: 'redeem.get-discounts-on-brand',
  ENTER_CODE: 'common.enter-code',
  EXCHANGE_POINTS: 'exchange.exchange-points',
  MILES: 'exchange.miles',
  POINTS: 'common.points',
  CRYPTO: 'exchange.crypto',
  ACCEPT_PRIVACY_POLICY: 'common.accept-privacy-policy',
  QIIBEE_PRIVACY_POLICY: 'qiibee Privacy Policy',
  QR_SCANNER_REQUIRES_CAMERA: 'qr-code.requires-camera-access',
  CAMERA_BLOCKED: 'qr-code.camera-blocked-common',
  CAMERA_BLOCKED_SAFARI: 'qr-code.camera-blocked-safari',
  CAMERA_BLOCKED_ANDROID_CHROME: 'qr-code.camera-blocked-android-chrome',
  QR_TO_ACCESS_CAMERA: 'qr-code.to-access-camera',
  QR_CAMERA_BLOCKED: 'qr-code.camera-is-blocked',
  DISMISS: 'common.dismiss',
  PLEASE: 'common.please',
  AND_THEN: 'common.and-then',
  REFRESH: 'common.refresh',
  NO_TRANSACTIONS_YET: 'transactions.no-transactions-yet',
  ALL_TRANSACTIONS: 'nav-header.all-transactions',
  LOG_OUT: 'nav-header.log-out',
  TERMS: 'common.terms',
  PRIVACY: 'common.privacy',
  COOKIES: 'common.cookies',
  TERMS_CONDITIONS: 'common.terms-conditions',
  PRIVACY_POLICY: 'common.privacy-policy',
  COOKIES_POLICY: 'common.cookies-policy',
  ACCEPT_TERMS_POLICY: 'brand:common.i-hereby-accept-terms-policy',
  ACCEPT_PRODUCT_UPDATES: 'brand:common.stay-updated-on-products',
  VIEW_TERMS_POLICY: 'brand:common.view-the-terms-policy',
  CLOSE: 'common.close',
  CHOOSE_YOUR_LANGUAGE: 'common.choose-your-language',
  DATE_TIME: 'common.date-time'
}

export const SERVER_ERROR_MESSAGES = {
  NFT_ALREADY_CLAIMED: 'NFT already claimed.',
  USER_HAS_ALREADY_USED_CODE: 'User has already used code'
}
